export default function Container({ children, className, ...props }) {
  return (
    <div className={["container mx-auto", className].filter(Boolean).join(" ")} {...props}>
      <>{children}</>
    </div>
  );
}
